import { Grid } from '@mui/material';
import { FaFacebookSquare, FaSoundcloud } from 'react-icons/fa';
import { GrInstagram } from 'react-icons/gr';
import { TfiYoutube } from 'react-icons/tfi';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ScrollToTop from './components/commons/ScrollToTop';
import Navbar from "./components/navbar/Navbar";
import { IExternalLink } from "./models/IExternalLink";
import { IMenuItem } from "./models/IMenuItem";
import ContactView from "./views/ContactView";
import EventsView from './views/EventsView';
import FanfaresView from './views/FanfaresView';
import FanfaronsView from "./views/FanfaronsView";
import WelcomeView from "./views/WelcomeView";


const menuItems: IMenuItem[] = [
    {path: '/', name: 'ACCUEIL', element: <WelcomeView/>},
    {path: '/fanfarons', name: 'FANFARONS', element: <FanfaronsView/>},
    {path: '/fanfarons/:id', name: 'FANFARONS', element: <FanfaronsView/>, display: false},
    {path: '/events', name: 'ÉVÈNEMENTS', element: <EventsView/>},
    {path: '/events/:id', name: 'ÉVÈNEMENTS', element: <EventsView/>, display: false},
    {path: '/fanfares', name: 'FANFARES', element: <FanfaresView/>},
    {path: '/fanfares/:id', name: 'FANFARES', element: <FanfaresView/>, display: false},
    {path: '/contact', name: 'CONTACT', element: <ContactView/>}
];

const externalLinks: IExternalLink[] = [
    {name: 'Facebook', url: 'https://www.facebook.com/terminusbrassband', icon: <FaFacebookSquare/>},
    {name: 'Instagram', url: 'https://www.instagram.com/terminusbrassband', icon: <GrInstagram/>},
    {name: 'Youtube', url: 'https://www.youtube.com/channel/UCnT15j859s1VY8FLNrqR4sg', icon: <TfiYoutube/>},
    {name: 'Soundcloud', url: 'https://soundcloud.com/terminusbrassband', icon: <FaSoundcloud/>}
];

const App = () => {

    return <>
        <BrowserRouter>
            <ScrollToTop />
            <Navbar menuItems={menuItems} externalLinks={externalLinks}/>

            <Grid container spacing={2}
                  style={{marginTop: 40, marginBottom: 40, paddingLeft: 80, paddingRight: 80}}>
                <Grid item xs={12}>
                    <Routes>
                        {menuItems.map(item =>
                            <Route key={item.path} path={item.path} element={item.element}/>)
                        }
                    </Routes>
                </Grid>
            </Grid>
        </BrowserRouter>
    </>
}

export default App;
